export const arrayHelper = {
  concat,
  getMaxVal,
  getMinVal,
  arraysEqual,
  getMaxValue,
  findByParam,
  sortByParam
};

function concat(...args) {
  return args.reduce((acc, val) => [...acc, ...val]);
}

function getMaxVal(propName, array) {
  return Math.max.apply(
    Math,
    array.map(o => {
      return o[propName];
    })
  );
}

function getMaxValue(array, param) {
  return array.length > 0
    ? Math.max.apply(
      Math,
      array.map(o => {
        return o[param];
      })
    ) + 1
    : 1;

}

function sortByParam(array, param) {
  if (array === null) { return []; }
  if (array.length < 1) { return []; }
  const updatedArray = Array.from(array);
  updatedArray.sort((a, b) => {
    let x = a[param];
    let y = b[param];
    return y < x ? 1 : y > x ? -1 : 0;
  });
  return updatedArray;
}




function findByParam(array, param, value) {
  var element = array.find((el) => {
    return el[param] === value;
  });
  if (!element) { return null; }
  return Object.assign({}, element);
}

function getMinVal(propName, array) {
  Math.min.apply(
    Math,
    array.map(o => {
      return o[propName];
    })
  );
}


function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length)
    return false;
  for (var i = arr1.length; i--;) {
    if (arr1[i] !== arr2[i])
      return false;
  }

  return true;
}